export default __webpack_public_path__ + "a5382878fe4e81b643ecb01cf4a88059.svg";